<template>
  <div class="doanswer" :class="curySkin">
    <div ref="topicContent" oncopy="return false" oncontextmenu="return false" class="tr-top"
      :style="{ height: `${tbDownX}px` }" v-html="topic.content"></div>
    <div class="tr-scroll" @mousedown="tbSrcollDown"></div>
    <div class="tr-main" :style="{ height: `calc(100% - ${tbDownX + 3}px)` }">
      <Editor ref="editor" v-model="editorContent" @blur="onblur" :topic="topic" :saveMenuCb="saveMenuCb"
        :historyCb="historyCb" :fullScreenCb="fullScreenCb" :floatScreenCb="floatScreenCb" :isFloat="is_float"
        :isFull="is_full" />
    </div>
    <history :topic="topic" :data="history" @restore="restore"></history>
  </div>
</template>

<script>
import Editor from "@/components/paper/editor2";
import History from "@/components/paper/history2"

export default {
  name: "doanswer",
  components: { Editor, History },
  data () {
    return {
      tbSrcoll: false,
      tbDownX: 76,
      editorContent: '',
      history: {
        show: false,
        text_answer: []
      },
      autoSaveTimeHandler: '',
    }
  },
  props: {
    curySkin: String,
    topic: Object,
    cur_question_id: String,
    is_full: Boolean,
    is_float: Boolean
  },
  watch: {
    topic: {
      immediate: true,
      handler () {
        this.editorContent = this.getTopicAnserLast(this.cur_question_id).answer;
        this.history.text_answer = this.answerItem[this.topic.question_id] || [];
        this.reflushTopicContHeight();
        // editor 滚动条回到0位置
        if (this.$refs.editor) {
          this.$refs.editor.scrollBack();
          this.$nextTick(() => {
            this.$refs.editor.calcRowCount(null, true);
          })
        }
      },
      deep: true
    },
    is_float: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          if (this.$refs.editor) {
            if (this.$refs.editor.editor.floatCancleCb) {
              this.$refs.editor.editor.floatCancleCb();
            }
          }
        }
      },
      deep: true
    },
  },
  computed: {
    //答案集合
    answerItem () {
      return this.$store.state.answer;
    },
    //params[0] 试题id  返回试题最后保存的答案json
    getTopicAnserLast () {
      return function (question_id) {
        let answer = this.answerItem[question_id];
        answer = answer ? JSON.parse(JSON.stringify(answer)) : {};
        answer = answer instanceof Array ? answer.reverse()[0] : {};
        return answer
      }
    }
  },
  created () {
    this.autoSaveTimeHandler = setInterval(() => {
      this.saveTextAnswer();
      this.history.text_answer = this.answerItem[this.topic.question_id] || [];
    }, 15 * 1000);
  },
  beforeDestroy () {
    if (this.autoSaveTimeHandler) {
      clearInterval(this.autoSaveTimeHandler);
    }
  },
  mounted () {
    this.reflushTopicContHeight();
  },
  methods: {
    reflushTopicContHeight () {
      // 计算题目高度，重设高度
      if (this.$refs.topicContent) {
        this.$refs.topicContent.style.height = 'auto';
        this.$nextTick(() => {
          this.tbDownX = this.$refs.topicContent.offsetHeight
        })
      }
    },
    // 上下拖拽
    tbSrcollDown (e) {
      this.tbSrcoll = true;
      document.addEventListener('mousemove', this.tbScrollMove);
      document.body.style.cursor = 'row-resize';
      document.body.style.userSelect = 'none';
      document.addEventListener('mouseup', this.tbScrollUp);
      this.disY = e.clientY;
      this.dragDomheight = e.target.parentNode.querySelector('.tr-top').offsetHeight; // 高度
    },
    tbScrollMove (e) {
      let top = e.clientY - this.disY;
      if (this.tbSrcoll) {
        this.tbDownX = this.dragDomheight + top;
      }
    },
    tbScrollUp () {
      this.tbSrcoll = false;
      document.removeEventListener('mousemove', this.tbScrollMove);
      document.removeEventListener('mouseup', this.tbScrollUp);
      document.body.style.cursor = 'default';
      document.body.style.userSelect = 'initial';
    },
    zoomJustCb () {
      if (this.$refs.editor) {
        this.$refs.editor.zoomJustCb();
      }
    },
    onblur () {
      this.saveTextAnswer();
    },
    //简答题15秒或者blur存储一次
    saveTextAnswer () {
      let hasSave = this.answerItem[this.topic.question_id];
      let answer = this.answerItem[this.topic.question_id] || [];
      if ((answer.length == 0 || this.editorContent != answer.slice(-1)[0].answer)) {
        if (this.editorContent == '' && !hasSave) {
          return;
        } else {
          answer.push({
            answer: this.editorContent,
            time: this.getNowFormatDate(),
            type: this.topic.question_type,
            text_num: this.getTextNum(this.editorContent)
          });
          this.history.text_answer = answer;
          this.saveAnswer(answer);
        }
      }
    },
    getNowFormatDate () {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var min = date.getMinutes();
      min = min < 10 ? '0' + min : min;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
    },
    getTextNum (html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      div.style.display = "none";
      document.body.appendChild(div)
      const length = div.innerText.length;
      document.body.removeChild(div)
      return length;
    },
    //保存答案
    saveAnswer (data) {
      let cur_question_id = this.cur_question_id;
      let answer = this.$store.state.answer || {};
      answer[cur_question_id] = data;

      //如果多选的选项是空，则删除这个答案
      if (typeof (data) == "object" && data.length == 0) {
        delete answer[cur_question_id]
      }
      if (typeof (data) == 'string' && data == '') {
        delete answer[cur_question_id]
      }
      this.$store.commit("answer", answer);
    },
    saveMenuCb () {
      this.saveTextAnswer();
    },
    //简答题恢复
    restore (content) {
      this.editorContent = content;
      this.saveTextAnswer();
    },
    historyCb () {
      this.history.show = true;
    },
    fullScreenCb (editor, isExit) {
      this.$emit('update:is_full', !isExit);
      this.$emit('fullScreen', !isExit);
    },
    floatScreenCb (editor, isFloat) {
      this.$emit('update:is_float', !isFloat);
      if (isFloat) {
        this.$emit('cancleFloat');
      } else {
        this.$emit('update:is_full', false);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.doanswer {
  height: 100%;

  &.skin1 {
    .tr-top {
      background-color: #ffffff;
    }
  }

  &.skin2 {
    .tr-top {
      background-color: #cce9cf;
    }
  }

  &.skin3 {
    .tr-top {
      background-color: #c1d3d6;
    }
  }

  &.skin4 {
    .tr-top {
      background-color: #f4f1e9;
    }
  }

  &.skin5 {
    .tr-top {
      background-color: #dce2f2;
    }
  }

  &.skin6 {
    .tr-top {
      background-color: #f1e5c8;
    }
  }

  .tr-top {
    height: 70px;
    padding:20px;
    width: 100%;
    font-size: 20px 10px 5px 20px;
    line-height: 1.6;
    box-sizing: border-box;
    overflow-y: auto;
  }

  .tr-scroll {
    width: 100%;
    height: 3px;
    background-color: #adadad;
    cursor: row-resize;
  }

  .tr-main {
    width: 100%;
    height: calc(100% - 73px);
    background-color: #ffffff;
  }
}
</style>